import AppRouter from "./approuter";
import { Content } from "./components/hooks/scrollbuttonstyles";
import ScrollButton from "./components/hooks/scrollbutton";
import CookieConsent from "./components/hooks/cookies";

function App() {
  return (
    <div>
      <AppRouter />
      <Content />
      <ScrollButton />
      <CookieConsent />
    </div>
  );
}

export default App;
